<template>
  <div class="noon-info">
    <h2>{{msg}}</h2>
    <p>“咦，这里空空的，还是去别处看看吧~”</p>
  </div>
</template>
<script>
  export default {
    name:"NoonInfo",
    props: {
      msg:{
        type: String
      }
    }
  }
</script>
<style scoped>
  .noon-info {
    padding-bottom: 150px;
  
    &:before {
       margin: 50px auto 41px auto;
       display: block;
       content: '';
       width: 256px;
       height: 297px;
       background: url("../../assets/book-none.png") 50% 50% no-repeat;
       background-size: 256px 297px;
     }
  
    h2 {
      font-family:"PingFangSC-Medium";
      font-size:34px;
      font-weight: 800;
      text-align: center;
      color:#323232;
      width: 100%;
    }
  
    p {
      font-family:"PingFangSC-Regular";
      font-size:26px;
      color:rgba(3,3,3,0.50);
      text-align:center;
      display: block;
      width: 100%;
      margin-top: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/commons/NoonInfo.vue